import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Request from "../../../helpers/request";
import * as url from "../../../helpers/url_helper";
import { toast } from "react-toastify";

interface DeleteSegmentProps {
  isOpen: boolean;
  toggle: () => void;
  segmentData: {
    id: string;
    _id?: string;
    name: string;
    description: string;
  } | null;
  onDeleteSuccess: () => void;
}

const DeleteSegment: React.FC<DeleteSegmentProps> = ({
  isOpen,
  toggle,
  segmentData,
  onDeleteSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    if (!segmentData?._id) {
      toast.error("Segment ID is required");
      return;
    }

    setLoading(true);
    try {
      const response = await Request.delete(
        `${url.BASE_URL}${url.DELETE_FILTER_SEGMENT}`,
        {
          segmentIds: segmentData._id,
        }
      );

      if (response.status === 200) {
        toast.success("Segment deleted successfully");
        onDeleteSuccess();
        toggle();
      }
    } catch (error: any) {
      console.error("Error deleting segment:", error);
      if (error?.response?.status === 401) {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("selectedPremiseID");
        localStorage.removeItem("selectedUserID");
        localStorage.removeItem("selectedUserEmail");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("permissions");
        window.location.reload();
      } else {
        toast.error(
          error?.response?.data?.message || "Failed to delete segment"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Delete Segment</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <div className="mb-3">
            <box-icon name="trash" size="48px" color="#dc3545"></box-icon>
          </div>
          <h5>Are you sure you want to delete this segment?</h5>
          <p className="text-muted mb-0">
            This action cannot be undone. This will permanently delete the
            segment <strong>{segmentData?.name}</strong> and remove all
            associated data.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="btn btn-dark"
          size="sm"
          onClick={toggle}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          className="btn btn-dark"
          size="sm"
          onClick={handleDelete}
          disabled={loading}
        >
          {loading && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          Delete Segment
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteSegment;
